// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"602d9daf","942":"6c5e9ab0"}[chunkId] + ".chunk.js");